export default __webpack_public_path__ + "static/media/Playground.607e8668.png";